module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "simple-card",
    staticStyle: {
      "background-color": "#0073B7"
    },
    on: {
      "mouseover": function($event) {
        return _vm.toggleOverlay(1)
      },
      "mouseleave": function($event) {
        return _vm.toggleOverlay(0)
      },
      "click": function($event) {
        $event.preventDefault();
        return _vm.showRatingQuizSelection($event)
      }
    }
  }, [_c('div', {
    ref: "overlay",
    staticClass: "simple-card-overlay"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "z-index": "2"
    }
  }, [_c('h3', {
    staticClass: "simple-card-title",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.ratingQuiz')))]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "color": "white",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.numberOfSolvedExercises')) + "   " + _vm._s(_vm.solvedExercises) + "/" + _vm._s(_vm.allExercises))]), _vm._v(" "), _c('span', {
    staticClass: "simple-card-content"
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "quiz-button-footer",
    staticStyle: {
      "z-index": "2"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.startQuiz')))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "id": 'selectSubgroupsModal'
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(1), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.ratingHistory.ratingQuiz')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('pages.exams.ratingResults.ratingQuizInfo')))]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    staticStyle: {
      "margin": "20px 0 10px 0"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.selectSubgroups')))]), _vm._v(" "), (_vm.loadingSubgroups) ? _c('span', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('pulse-loader', {
    attrs: {
      "color": _vm.spinnerColor,
      "size": _vm.spinnerSize
    }
  })], 1) : _vm._e(), _vm._v(" "), [_c('div', {
    staticClass: "form-group"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.filteredSubgroups), function(subgroup) {
    return _c('div', {
      key: subgroup.id
    }, [_c('div', {
      style: ('margin-left: ' + (2 * subgroup.nivo) + 'em')
    }, [(subgroup.list) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.izbranePodskupine),
        expression: "izbranePodskupine"
      }],
      attrs: {
        "type": "checkbox",
        "id": subgroup.id
      },
      domProps: {
        "value": subgroup.id,
        "checked": Array.isArray(_vm.izbranePodskupine) ? _vm._i(_vm.izbranePodskupine, subgroup.id) > -1 : (_vm.izbranePodskupine)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.izbranePodskupine,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = subgroup.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.izbranePodskupine = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.izbranePodskupine = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.izbranePodskupine = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('label', {
      attrs: {
        "for": subgroup.id
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleSubgroup(subgroup)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(!subgroup.list ? _vm.expandedSymbol(subgroup) : '') + " " + _vm._s(_vm._f("pickTranslation")(subgroup.name)) + "\n                    ")]), _vm._v(" "), (!subgroup.list) ? _c('span', {
      staticClass: "text-light-blue pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectAllSbgroupsInTree(subgroup.id, true)
        }
      }
    }, [_vm._v("\n                      (" + _vm._s(_vm.$t('pages.subgroups.addAll')) + ")\n                    ")]) : _vm._e(), _vm._v(" "), (!subgroup.list) ? _c('span', {
      staticClass: "text-light-blue pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectAllSbgroupsInTree(subgroup.id, false)
        }
      }
    }, [_vm._v("\n                      (" + _vm._s(_vm.$t('pages.subgroups.removeAll')) + ")\n                    ")]) : _vm._e()])])
  }), 0)], 1)], _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.subgroups.selectDuration')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.izbranoTrajanje),
      expression: "izbranoTrajanje"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.izbranoTrajanje = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20 min")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30 min")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "45"
    }
  }, [_vm._v("45 min")])])]), _vm._v(" "), (_vm.adminView) ? _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.createQuiz),
      expression: "createQuiz"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.createQuiz) ? _vm._i(_vm.createQuiz, null) > -1 : (_vm.createQuiz)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.createQuiz,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.createQuiz = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.createQuiz = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.createQuiz = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('pages.subgroups.createQuizForOtherUsers')) + "\n          ")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.createQuiz) ? _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.startRatingQuiz($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.createQuiz')))]) : _c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.startRatingQuiz($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.startQuiz')))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "info-box-icon trophy-icon"
  }, [_c('i', {
    staticClass: "fa fa-trophy"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-773b819a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-773b819a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rating/cards/RatingQuizButton.vue
// module id = 1451
// module chunks = 1